import { Component, inject } from '@angular/core';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';
import { firstValueFrom, Observable } from 'rxjs';
import { CommonModalService, generateId, OptionsList } from 'gung-common';
import { CustomPageConfigService } from '../../../../../services/custom-page/custom-page-config.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageConfigService } from '../../../../../services/language-config/language-config.service';

@Component({
  selector: 'lib-dynamic-page-dc-image-andtext',
  standalone: false,
  templateUrl: './dynamic-page-dc-image-and-text.component.html',
  styleUrl: './dynamic-page-dc-image-and-text.component.scss'
})
export class DynamicPageDcImageAndTextComponent extends DynamicPageDcBaseComponent {
  protected customPagesService = inject(CustomPageConfigService);
  protected modalService = inject(CommonModalService);
  protected translateService = inject(TranslateService);
  protected languageConfigService = inject(LanguageConfigService);

  translateLangs = this.languageConfigService
    .getLanguages()
    .filter(l => l.enabled)
    .map(l => l.short);

  currentLang = this.translateService.currentLang;

  idUploadInput = generateId();
  imageUpload: File[];
  translate = false;

  elementId = 'card-info';
  fields = {
    translate: false,
    title: '<h4 style="text-align: center;"><span style="font-weight: normal;">Card Title</span></h4>',
    description: 'Description',
    backgroundColor: 'transparent',
    backgroundImage: null,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 15,
    paddingRight: 15,
    paddingBottom: 15,
    paddingLeft: 15,
    minHeight: 200,
    displayVertical: 'center',
    displayHorizontal: 'center',
    contentMaxWidth: null
  };

  horizontalOptions: OptionsList[] = [
    {
      id: 'center',
      name: 'center'
    },
    {
      id: 'flex-start',
      name: 'Left'
    },
    {
      id: 'flex-end',
      name: 'Right'
    }
  ];

  verticalOptions: OptionsList[] = [
    {
      id: 'center',
      name: 'center'
    },
    {
      id: 'flex-start',
      name: 'Top'
    },
    {
      id: 'flex-end',
      name: 'Bottom'
    }
  ];

  changeTranslate() {
    this.translate = this.element.fields.translate;
    const translatableFields = ['title', 'description', 'button1Text', 'button2Text'];
    if (this.translate) {
      translatableFields.forEach(field => {
        let currentValue = this.element.fields[field];

        if (typeof currentValue === 'string' || !currentValue) {
          currentValue = {
            value: currentValue || '',
            i18n: {}
          };
        }

        this.translateLangs.forEach((lang: string) => {
          if (!currentValue.i18n[lang]) {
            currentValue.i18n[lang] = currentValue.value;
          }
        });

        this.element.fields[field] = currentValue;
      });
    } else {
      translatableFields.forEach(field => {
        const currentValue = this.element.fields[field];

        if (currentValue && typeof currentValue === 'object' && 'value' in currentValue) {
          this.element.fields[field] = {
            ...currentValue,
            value: currentValue.value
          };
        }
      });
    }
  }

  uploadImage() {
    const fn = async (files: File[]) => {
      const imageObject = {
        index: 0,
        description: 'custompage image - ' + new Date().getTime(),
        category: 'custompage image',
        s3Uri: 'images/no-image.jpg'
      };
      const formData = new FormData();
      formData.append('file', files[0]);
      formData.append('productImage', JSON.stringify(imageObject));
      this.customPagesService.uploadImageS3(formData);
      return await firstValueFrom(this.customPagesService.uploadImageS3(formData));
    };
    this.modalService
      .openUploadModalComponent(fn, true, true, 'image/jpg, image/jpeg, image/png', {
        translateTag: 'UPLOAD_BACKGROUD_IMAGE',
        class: 'mb-2 text-center'
      })
      .then(res => {
        if (res) {
          this.element.fields.backgroundImage = `https://cdn3.gung.io/${res.s3Uri}`;
        }
      });
  }
}
